/* eslint-disable default-case */
import produce from 'immer';

import {
  types,
  IntegrationsState,
  CreateIntegrationPayload,
  UpdateIntegrationPayload,
  IntegrationsActionTypes,
  GetIntegrationsSuccess,
  GetIntegrationsError,
  GetIntegrationsPending,
  CreateIntegrationPending,
  CreateIntegrationError,
  UpdateIntegrationPending,
  UpdateIntegrationSuccess,
  UpdateIntegrationError,
  DeleteIntegrationPending,
  DeleteIntegrationError,
  Integration
} from './types';

// Actions
export const actions = {
  getIntegrations: (): IntegrationsActionTypes => ({ type: types.GET_INTEGRATIONS.REQUEST }),
  createIntegration: (payload: CreateIntegrationPayload): IntegrationsActionTypes => ({
    type: types.CREATE_INTEGRATION.REQUEST,
    payload
  }),
  updateIntegration: (payload: UpdateIntegrationPayload): IntegrationsActionTypes => ({
    type: types.UPDATE_INTEGRATION.REQUEST,
    payload
  }),
  deleteIntegration: (payload: { id: string }): IntegrationsActionTypes => ({
    type: types.DELETE_INTEGRATION.REQUEST,
    payload
  }),
  resetAction: (): IntegrationsActionTypes => ({ type: types.RESET_ACTION }),
  resetError: (): IntegrationsActionTypes => ({ type: types.RESET_ERROR })
};

// Initial State
export const initialState: IntegrationsState = {
  integrations: [],
  action: {
    pending: false,
    success: false,
    error: null
  }
};

// Reducer
export const reducer = (
  state: IntegrationsState = initialState,
  action: IntegrationsActionTypes
): IntegrationsState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case types.GET_INTEGRATIONS.PENDING:
      case types.CREATE_INTEGRATION.PENDING:
      case types.UPDATE_INTEGRATION.PENDING:
      case types.DELETE_INTEGRATION.PENDING:
        draft.action.pending = (
          action as
            | GetIntegrationsPending
            | CreateIntegrationPending
            | UpdateIntegrationPending
            | DeleteIntegrationPending
        ).payload;
        break;
      case types.GET_INTEGRATIONS.ERROR:
      case types.CREATE_INTEGRATION.ERROR:
      case types.UPDATE_INTEGRATION.ERROR:
      case types.DELETE_INTEGRATION.ERROR:
        draft.action.error = (
          action as GetIntegrationsError | CreateIntegrationError | UpdateIntegrationError | DeleteIntegrationError
        ).payload;
        break;
      case types.GET_INTEGRATIONS.SUCCESS:
        draft.integrations = (action as GetIntegrationsSuccess).payload;
        break;
      case types.CREATE_INTEGRATION.SUCCESS:
      case types.DELETE_INTEGRATION.SUCCESS:
        draft.action.success = true;
        break;
      case types.UPDATE_INTEGRATION.SUCCESS:
        const payload = (action as UpdateIntegrationSuccess).payload;
        draft.action.success = true;
        if (draft.integrations.length) {
          const index = draft.integrations.findIndex((i) => i.id === (payload as Integration).id);
          if (index > -1) {
            Object.assign(draft.integrations[index], payload);
          }
        }
        break;
      case types.RESET_ERROR:
        draft.action.error = initialState.action.error;
        break;
      case types.RESET_ACTION:
        draft.action = initialState.action;
        break;
    }
  });
};
